import {observable, action} from 'mobx'


export default class ApiSettings {
    // @observable ya_app_id;
    @observable ya_api_token
    @observable debug
    @observable order_action_ship
    @observable order_action_delete
    @observable order_action_pickup
    @observable order_action_complete
    @observable dont_create_unpaid_orders

    constructor(settings) {
        if (!settings) {
            return
        }

        this.ya_app_id = settings.ya_app_id
        this.ya_api_token = settings.ya_api_token
        this.order_action_ship = settings.order_action_ship
        this.order_action_delete = settings.order_action_delete
        this.order_action_pickup = settings.order_action_pickup
        this.order_action_complete = settings.order_action_complete
        this.dont_create_unpaid_orders = settings.dont_create_unpaid_orders
    }
}